/* eslint-disable no-inline-comments */
/* eslint-disable lines-around-comment */
import CardTraining from './CardTrainings'
import TestimoniesSlider from './TestimoniesSlider'
import ProjectSlider from './ProjectSlider'
import CoverProject from './CoverProject'
import FullwidthMedia from './FullwidthMedia'
import ScrollingCovers from './ScrollingCovers'
import InfoImages from './InfoImages'
import Dropdown from './Dropdown'
import HomeCover from './HomeCover'
import LastPosts from './LastPosts'
import SocialMedia from './SocialMedia'
import Filter from './Filter'
import Promotion from './Promotion'
import Showreel from './Showreel'
import SliderBlockProjects from "./SliderBlockProjects";
import SliderHome from './SliderHome'
import Partners from './Partners'
import Video from './Video'
import Form from './Form'
import BackgroundVideo from './BackgroundVideo'
/* generated script here */

const blockList = [
  {
    name: 'slider-projects-container',
    Class: SliderBlockProjects
  },
  {
    name: 'social-media',
    Class: SocialMedia
  },
  {
    name: 'trainings',
    Class: CardTraining
  },
  {
    name: 'b-testimonies',
    Class: TestimoniesSlider
  },
  {
    name: 'b-project-slider',
    Class: ProjectSlider
  },
  {
    name: 'c-cover-project',
    Class: CoverProject
  },
  {
    name: 'b-fullwidth-media',
    Class: FullwidthMedia
  },
  {
    name: 'b-scrolling-covers',
    Class: ScrollingCovers
  },
  {
    name: 'dropdown',
    Class: Dropdown
  },
  {
    name: 'b-info-images',
    Class: InfoImages
  },
  {
    name: 'b-promotion',
    Class: Promotion
  },
  {
    name: 'c-showreel',
    Class: Showreel
  },
  {
    name: 'b-last-posts',
    Class: LastPosts,
    mobile: false
  },
  {
    name: 'b-last-events',
    Class: LastPosts,
    mobile: false
  },
  {
    name: 'news__cards',
    Class: LastPosts,
    mobile: false
  },
  {
    name: 'b-partners',
    Class: Partners,
    mobile: false
  },
  {
    name: 'c-home-cover',
    Class: HomeCover
  },
  {
    name: 'c-home-cover',
    Class: SliderHome
  },
  {
    name: 'c-video',
    Class: Video
  },
  {
    name: 'c-background-video',
    Class: BackgroundVideo
  },
  {
    name: 'gform_wrapper',
    Class: Form
  },
  {
    name: 'filters',
    Class: Filter
  }/* generated class */
]

export default blockList
